import PropTypes from 'prop-types';
import { StyledTitle, StyledSubtitle } from './UpdateDate.style';

const UpdateDate = ({ children }) => {
  return (
    <StyledTitle>
      Last updated: <StyledSubtitle>{children}</StyledSubtitle>
    </StyledTitle>
  );
};

UpdateDate.propTypes = {
  children: PropTypes.string.isRequired,
};

export default UpdateDate;
